'use strict';

import type { UserClientPortal } from '../../Entities/User/UserClientPortal';
import { EntityCollection } from '../EntityCollection';

export class UserClientPortalCollection extends EntityCollection<UserClientPortal> {}
